import classNames from 'classnames'
import { MdOutlineClear, MdAdd } from 'react-icons/md'

import type { ReactElement, ReactNode, SyntheticEvent } from 'react'

import Badge from '~/components/Badge'
import Button from '~/components/Buttons/Button'

import './section.scss'

interface ItemProps {
  children: ReactNode
  className?: string
  isNavigable?: boolean
  onClick?: () => void
  onDelete?: () => void
}

export const SectionItem = ({
  children,
  className,
  isNavigable = false,
  onClick,
  onDelete,
}: ItemProps): ReactElement => {
  const sectionItemClasses = classNames('section-item', className, { navigable: isNavigable })

  const handleDelete = (evt: SyntheticEvent<HTMLButtonElement>) => {
    evt.stopPropagation()
    onDelete && onDelete()
  }

  return (
    <div className={sectionItemClasses} onClick={onClick}>
      {children}
      <div className="section-item-actions">
        {onDelete ? (
          <Button className="delete-cta" ghost onClick={handleDelete}>
            <MdOutlineClear color="#626262" size={15} />
          </Button>
        ) : null}
      </div>
    </div>
  )
}

interface Props {
  children: ReactNode
  className?: string
  itemsCount: number
  onClickAdd?: () => void
  title: string
  withAdd?: boolean
}

const Section = ({ children, className, itemsCount, onClickAdd, title }: Props): ReactElement => {
  return (
    <div className={classNames('section-layout', className)}>
      <div className="section-header">
        <div className="section-title">
          {title} <Badge className="items-count" value={itemsCount} />
        </div>
        {onClickAdd ? (
          <div className="section-actions">
            <Button onClick={onClickAdd} size="small">
              <MdAdd color="#fff" size={15} /> Add
            </Button>
          </div>
        ) : null}
      </div>
      <div className="section-body">{children}</div>
    </div>
  )
}

export default Section
